<template>
  <div class="billDashboard">
    <vx-card style="min-height: 540px">
      <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: true,
        }"
        :sort-options="{
          enabled: false,
        }"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-column-filter="onColumnFilter"
        @on-row-dblclick="navigate"
        styleClass="vgt-table condensed"
      />
    </vx-card>
  </div>
</template>

<script>
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      components: {
        flatPickr,
      },
      isLoading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
        currentPage: 1,
        limit: 10,
      },
      columns: [
        {
          label: "BILL NO",
          field: "billNo",
          filterOptions: {
            enabled: true,
            placeholder: " ",
            trigger: "",
          },
          thClass: "text-left pl-4",
          tdClass: "text-left pl-4",

          width: "100px",
        },
        {
          label: "BILL DATE",
          field: "billDate",
          type: "date",
          dateInputFormat: "dd/mm/yyyy",
          dateOutputFormat: "dd-mm-yyyy",
          filterOptions: {
            enabled: true,
            placeholder: "dd/mm/yy",
            trigger: "",
          },
          width: "130px",
        },
        {
          label: "PATIENT ID",
          field: "patientId",
          filterOptions: {
            enabled: true,
            placeholder: " ",
            trigger: "",
          },
          thClass: "text-left pl-4",
          tdClass: "text-left pl-4",
          width: "100px",
        },
        {
          label: "PATIENT NAME ",
          field: "patientName",
          filterOptions: {
            enabled: true,
            placeholder: " ",
            trigger: "",
          },
          width: "200px",
        },
        {
          label: "PHONE NO",
          field: "phoneNumber",
          filterOptions: {
            enabled: true,
            placeholder: " ",
            trigger: "",
          },
          width: "130px",
        },

        {
          label: "BILL TYPE",
          field: "billType",
          filterOptions: {
            enabled: true,
            placeholder: " ",
            trigger: "",
          },

          thClass: "text-center",
          tdClass: "text-center",
          width: "130px",
        },
        {
          label: "RECVD AMOUNT",
          field: "receivedAmount",
          thClass: "text-center",
          tdClass: "text-center",
          width: "120px",
        },
        {
          label: "TOTAL AMOUNT",
          field: "totalAmount",
          thClass: "text-center",
          tdClass: "text-center",
          width: "120px",
        },
      ],
    };
  },

  mounted() {
    let inputs = ['input[placeholder="dd/mm/yy"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        // dateFormat: "m-d-Y",
        dateFormat: "d/m/Y",
        // mode: "range",
        allowInput: true,
      });
    });
console.log(
      " Stored filters from Vuex:",
      this.$store.state.billDashboardFilters
    );
    const savedFilters = this.$store.state.billDashboardFilters;
  console.log("savedfilters",savedFilters)
    if (savedFilters) {
      this.serverParams = savedFilters;

      const updatedColumns = this.columns.map((col) => {
        if (savedFilters.filter && savedFilters.filter[col.field]) {
          return {
            ...col,
            filterOptions: {
              ...(col.filterOptions || {}),
              filterValue: savedFilters.filter[col.field],
            },
          };
        }
        return col;
      });
      this.columns = updatedColumns;

      this.$store.commit("updatebillDashboardFilters", null);
    }
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      console.log("parameter updated");
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      console.log(params);
      this.updateParams({
        currentPage: params.currentPage,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      console.log("filter called");
      this.updateParams({
        filter: params.columnFilters,
      });
      this.loadItems();
    },
    loadItems() {
         this.isLoading = true;
      console.log("server parameter", this.serverParams);
      this.$http
        .post(
          "/getBillDashboard",

          JSON.stringify(this.serverParams),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("response from Bill back end", response.data.data);
          this.totalRecords = response.data.data.recordsTotal;
          this.rows = response.data.data.records;
        })
        .catch((error) => {
          console.error("Error fetching billing data", error);
        }).finally(() => {
      this.isLoading = false;
    });
    },
    navigate(item) {
      this.$store.commit("updatebillDashboardFilters", this.serverParams);
      console.log("billdashboard filters",this.serverParams)
      this.$router.push({
        path: "billing",
        query: {
          billId: item.row.billNo,
          patientId: item.row.patientId,
           from: "billingDashboard"
        },
      });
    },
  },
};
</script>
<style>
.vgt-table thead th {
  background: white;
}
.vgt-wrap__footer {
  background: white;
  border: none;
}
table.vgt-table {
  font-size: 12px;
  border: none;
}
.vgt-right-align {
  text-align: left;
}

.vgt-table.condensed tr {
  height: 56px;
}
.vgt-table.condensed td {
  padding-top: 19px;
}
.vgt-input {
  border: none;
}

.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
.flatpickr-calendar {
  width: 305.625px !important;
  /* height: 300.627px !important;  */
}
.flatpickr-rContainer {
  width: 95% !important;
}
.dayContainer {
  min-width: 86% !important;
  max-width: 86% !important;
}
.flatpickr-monthDropdown-months {
  margin-left: -18%;
}
.flatpickr-monthDropdown-month {
  font-size: 11 !important;
}
.flatpickr-next-month {
  right: 57px !important;
}
.flatpickr-months {
  width: 97%;
}
.billDashboard .vgt-table thead th:nth-child(6) input {
  
  text-align: center !important;
}

</style>